import React from 'react';
import styled from '@emotion/styled';
import { Chip, Typography } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';

type ImageWidgetAddlProps = {
  file_display_name?: string;
  label?: string;
};

const ImageWidget = (props: WidgetProps) => {
  const { value, schema } = props;
  const addlProps: ImageWidgetAddlProps  = schema?.props || {};

  return (
    <ImageWrapper>
      <div>
        <Image>
          {addlProps?.label && <Chip color="info" label={addlProps?.label} />}
          <img src={value} height={400} />
        </Image>
        <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
          {addlProps.file_display_name || '(none)'}
        </Typography>
      </div>
    </ImageWrapper>
  );
};

export default ImageWidget;

const ImageWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const Image = styled.div`
  position: relative;
  .MuiChip-root {
    position: absolute;
    top: ${({ theme }) => theme.spacing(2)};
    left: ${({ theme }) => theme.spacing(2)};
  }
`;
